import DashboardIcon from "@mui/icons-material/Dashboard";
import StoreIcon from "@mui/icons-material/Store";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import InventoryIcon from "@mui/icons-material/Inventory";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";
import SettingsIcon from "@mui/icons-material/Settings";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import TabletMacIcon from "@mui/icons-material/TabletMac";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DevicesIcon from "@mui/icons-material/Devices";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import BusinessIcon from "@mui/icons-material/Business";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ArchiveIcon from "@mui/icons-material/Archive";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HistoryIcon from "@mui/icons-material/History";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MapIcon from "@mui/icons-material/Map";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import TuneIcon from "@mui/icons-material/Tune";
import PublicIcon from "@mui/icons-material/Public";
import BadgeIcon from "@mui/icons-material/Badge";
import CategoryIcon from "@mui/icons-material/Category";
import SellIcon from "@mui/icons-material/Sell";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CampaignIcon from "@mui/icons-material/Campaign";
import TabletIcon from "@mui/icons-material/Tablet";
import StorageIcon from "@mui/icons-material/Storage";
import { getPOSSalesArchiveText } from "../../utils/posSalesArchiveText";
import { getWholesaleSalesArchiveText } from "../../utils/wholesaleSalesArchiveText";

const link = (id, to, labelKey, Icon, isVisible, isSelected) => ({
  id,
  to,
  labelKey,
  Icon,
  isVisible,
  isSelected,
});

export const sidebarHomeItem = link(
  "home",
  "/home",
  "Home",
  DashboardIcon,
  () => true,
  (pathname) => pathname === "/home"
);

export const sidebarGroups = [
  {
    id: "sales",
    titleKey: "SidebarGroupSales",
    Icon: ShoppingCartIcon,
    items: [
      link(
        "pos-dashboard",
        "/POSDashboard",
        "POSDashboard",
        StoreIcon,
        (decoded) => decoded?.can_access_pos_dashboard,
        (pathname) => pathname === "/POSDashboard"
      ),
      link(
        "pos-dashboard-with-combo",
        "/POSDashboardWithCombo",
        "POSDashboardWithCombo",
        StorefrontIcon,
        (decoded) => decoded?.can_access_pos_dashboard,
        (pathname) => pathname === "/POSDashboardWithCombo"
      ),
      link(
        "sales-difference",
        "/SalesDifference",
        "SalesDifference",
        CompareArrowsIcon,
        (decoded) => decoded?.can_access_sales_difference,
        (pathname) => pathname === "/SalesDifference"
      ),
      link(
        "supervisors-dashboard",
        "/SupDashboard",
        "SupervisorsDashboard",
        StoreIcon,
        (decoded) => decoded?.can_access_Supervisors_dashboard,
        (pathname) => pathname === "/SupDashboard"
      ),
      link(
        "branches",
        "/branches",
        "BranchesMenu",
        BusinessIcon,
        (decoded) => decoded?.can_access_branches,
        (pathname) => pathname.startsWith("/branches")
      ),
      link(
        "shift-gaps",
        "/shift-closings-openings",
        "ShiftGapsReport",
        AccessTimeIcon,
        (decoded) => decoded?.can_access_shift_gaps_report,
        (pathname) => pathname === "/shift-closings-openings"
      ),
      link(
        "item-cost-by-period",
        "/item-cost-by-period-list",
        "ItemCostByPeriod",
        ListAltIcon,
        (decoded) => decoded?.can_access_items_cost_by_period,
        (pathname) => pathname === "/item-cost-by-period-list"
      ),
      link(
        "pos-live-data",
        "/POSLiveData",
        "POSLiveData",
        AutoGraphIcon,
        (decoded) => decoded?.can_access_live_data,
        (pathname) => pathname === "/POSLiveData"
      ),
    ],
  },
  {
    id: "branch-inventory",
    titleKey: "SidebarGroupBranchInventory",
    Icon: StoreIcon,
    items: [
      link(
        "branch-current-inventory",
        "/branch-current-inventory",
        "BranchCurrentInventory",
        AssignmentIcon,
        (decoded) => decoded?.can_access_branch_current_inv,
        (pathname) => pathname === "/branch-current-inventory"
      ),
      link(
        "hourly-inventory-balance",
        "/hourly-inventory-balance",
        "HourlyInventoryBalance",
        ViewTimelineIcon,
        (decoded) => decoded?.can_access_hourly_inventory_balance,
        (pathname) => pathname === "/hourly-inventory-balance"
      ),
      link(
        "hourly-inventory-balance-history",
        "/hourly-inventory-balance-history",
        "HourlyInventoryBalanceHistory",
        ViewTimelineIcon,
        (decoded) => decoded?.can_access_hourly_inventory_balance_history,
        (pathname) => pathname === "/hourly-inventory-balance-history"
      ),
      link(
        "pastry-outage-hours-summary",
        "/pastry-outage-hours-summary",
        "PastryOutageHoursSummary",
        ViewTimelineIcon,
        (decoded) => decoded?.can_access_pastry_outage_hours_summary,
        (pathname) => pathname === "/pastry-outage-hours-summary"
      ),
      link(
        "inventory-count",
        "/inventory",
        "InventoryCount",
        InventoryIcon,
        (decoded) => decoded?.can_access_inventory_count,
        (pathname) => pathname === "/inventory"
      ),
    ],
  },
  {
    id: "warehouses",
    titleKey: "SidebarGroupWarehouses",
    Icon: WarehouseIcon,
    items: [
      link(
        "dispatch-by-category",
        "/dispatch-by-category",
        "DispatchByCategory",
        WarehouseIcon,
        (decoded) =>
          decoded?.can_access_sit_dispatch_by_category &&
          decoded?.show_cost_price,
        (pathname) => pathname === "/dispatch-by-category"
      ),
      link(
        "dispatch-by-item",
        "/dispatch-by-item",
        "DispatchByItem",
        WarehouseIcon,
        (decoded) => decoded?.can_access_sit_dispatch_by_item,
        (pathname) => pathname === "/dispatch-by-item"
      ),
      link(
        "dispatch-by-details",
        "/dispatch-by-details",
        "DispatchByDetails",
        WarehouseIcon,
        (decoded) => decoded?.can_access_sit_dispatch_by_details,
        (pathname) => pathname === "/dispatch-by-details"
      ),
      link(
        "wh-dashboard",
        "/WHDashboard",
        "WHDashboard",
        WarehouseIcon,
        (decoded) => decoded?.can_access_sit_dispatch_by_item,
        (pathname) => pathname === "/WHDashboard"
      ),
    ],
  },
  {
    id: "wholesale",
    titleKey: "SidebarGroupWholesale",
    Icon: LocalShippingIcon,
    items: [
      link(
        "wholesale-collections",
        "/WholesaleCollectionsDashboard",
        "WholesaleCollectionsDashboard",
        LocalShippingIcon,
        (decoded) => decoded?.can_access_wholesale_dashboard,
        (pathname) => pathname === "/WholesaleCollectionsDashboard"
      ),
      link(
        "wholesale-sales",
        "/WholesaleDashboard",
        "Wholesale Sales",
        LocalShippingIcon,
        (decoded) => decoded?.can_access_wholesale_dashboard,
        (pathname) => pathname === "/WholesaleDashboard"
      ),
    ],
  },
  {
    id: "finance",
    titleKey: "SidebarGroupFinance",
    Icon: AccountBalanceIcon,
    items: [
      link(
        "supplier-review-balance",
        "/vendor",
        "Supplier Review Balance",
        ListAltIcon,
        (decoded) => decoded?.can_access_supplier_review_balance,
        (pathname) => pathname === "/vendor"
      ),
    ],
  },
  {
    id: "marketing",
    titleKey: "SidebarGroupMarketing",
    Icon: CampaignIcon,
    items: [
      link(
        "used-cards",
        "/UsedCardsByLoyaltyProgram",
        "UsedCardsByLoyaltyProgram",
        LoyaltyIcon,
        (decoded) => decoded?.can_access_used_cards_report,
        (pathname) => pathname === "/UsedCardsByLoyaltyProgram"
      ),
    ],
  },
  {
    id: "tablet",
    titleKey: "SidebarGroupTablet",
    Icon: TabletIcon,
    items: [
      link(
        "orders-source-per-hour",
        "/OrdersSourcePerHour",
        "OrdersSourcePerHour",
        DevicesIcon,
        (decoded) => decoded?.can_access_orders_source_per_hour_report,
        (pathname) => pathname === "/OrdersSourcePerHour"
      ),
      link(
        "orders-branch-source-per-hour",
        "/OrdersBranchSourcePerHour",
        "OrdersBranchSourcePerHour",
        TabletMacIcon,
        (decoded) => decoded?.can_access_orders_source_per_branch_report,
        (pathname) => pathname === "/OrdersBranchSourcePerHour"
      ),
      link(
        "orders-branch-source-per-period",
        "/OrdersBranchSourcePerPeriod",
        "OrdersBranchSourcePerPeriod",
        DateRangeIcon,
        (decoded) => decoded?.can_access_orders_source_per_branch_period_report,
        (pathname) => pathname === "/OrdersBranchSourcePerPeriod"
      ),
    ],
  },
  {
    id: "master-data",
    titleKey: "SidebarGroupMasterData",
    Icon: StorageIcon,
    items: [
      link(
        "countries",
        "/countries",
        "Countries",
        PublicIcon,
        (decoded) => decoded?.can_manage_countries,
        (pathname) => pathname === "/countries"
      ),
      link(
        "cities",
        "/cities",
        "Cities",
        LocationCityIcon,
        (decoded) => decoded?.can_manage_cities,
        (pathname) => pathname === "/cities"
      ),
      link(
        "sales-areas",
        "/sales-areas",
        "SalesAreas",
        MapIcon,
        (decoded) => decoded?.can_manage_sales_areas,
        (pathname) => pathname === "/sales-areas"
      ),
      link(
        "rms-product-categories",
        "/rms-product-categories",
        "RmsProductCategories",
        CategoryIcon,
        (decoded) => decoded?.can_access_products,
        (pathname) => pathname === "/rms-product-categories"
      ),
      link(
        "rms-products",
        "/rms-products",
        "RmsProducts",
        InventoryIcon,
        (decoded) => decoded?.can_access_products,
        (pathname) => pathname === "/rms-products"
      ),
      link(
        "employees",
        "/employees",
        "Employees",
        BadgeIcon,
        (decoded) => decoded?.can_manage_employees,
        (pathname) => pathname === "/employees"
      ),
      link(
        "master-warehouses",
        "/warehouses",
        "Warehouses",
        WarehouseIcon,
        (decoded) => decoded?.can_manage_warehouses,
        (pathname) => pathname === "/warehouses"
      ),
    ],
  },
  {
    id: "administration",
    titleKey: "SidebarGroupAdministration",
    Icon: SettingsIcon,
    items: [
      {
        ...link(
          "pos-sales-archive",
          "/pos-sales-archive",
          null,
          ArchiveIcon,
          (decoded) => decoded?.can_access_pos_sales_archive,
          (pathname) => pathname.startsWith("/pos-sales-archive")
        ),
        getLabel: (_t, language) =>
          getPOSSalesArchiveText(language).screenTitle,
      },
      {
        ...link(
          "wholesale-sales-archive",
          "/wholesale-sales-archive",
          null,
          ReceiptLongIcon,
          (decoded) => decoded?.can_access_wholesale_sales_archive,
          (pathname) => pathname.startsWith("/wholesale-sales-archive")
        ),
        getLabel: (_t, language) =>
          getWholesaleSalesArchiveText(language).screenTitle,
      },
      link(
        "legacy-sales-archive",
        "/legacy-sales-archive",
        "LegacySalesArchive",
        Inventory2Icon,
        (decoded) => decoded?.can_access_legacy_sales_archive,
        (pathname) => pathname === "/legacy-sales-archive"
      ),
      link(
        "legacy-sales-settings",
        "/legacy-sales-settings",
        "LegacySalesSettings",
        SettingsIcon,
        (decoded) => decoded?.can_access_legacy_sales_archive,
        (pathname) => pathname === "/legacy-sales-settings"
      ),
      link(
        "promotion-items",
        "/promotion-items",
        "PromotionItems",
        LocalOfferIcon,
        (decoded) => decoded?.can_access_promotion_items,
        (pathname) => pathname === "/promotion-items"
      ),
      link(
        "prepare-item-cost-by-period",
        "/prepare-item-cost-by-period",
        "PrepareItemCostByPeriod",
        CompareArrowsIcon,
        (decoded) => decoded?.can_access_items_cost_by_period,
        (pathname) => pathname === "/prepare-item-cost-by-period"
      ),
      link(
        "hourly-inventory-snapshot-settings",
        "/hourly-inventory-snapshot-settings",
        "HourlyInventorySnapshotSettings",
        TuneIcon,
        (decoded) => decoded?.can_manage_hourly_inventory_snapshot_settings,
        (pathname) => pathname === "/hourly-inventory-snapshot-settings"
      ),
      link(
        "sit-dispatch-filter-settings",
        "/sit-dispatch-filter-settings",
        "SitDispatchFilterSettings",
        FilterAltIcon,
        (decoded) => decoded?.can_manage_sit_dispatch_filter_settings,
        (pathname) => pathname === "/sit-dispatch-filter-settings"
      ),
      link(
        "user-management",
        "/UserManagement",
        "ManagmentUsers",
        GroupsIcon,
        (decoded) => decoded?.permissions?.includes("repAPI.can_manage_users"),
        (pathname) => pathname === "/UserManagement"
      ),
      link(
        "audit-log",
        "/audit-log",
        "AuditLog",
        HistoryIcon,
        (decoded) => decoded?.can_access_audit_log,
        (pathname) => pathname === "/audit-log"
      ),
      link(
        "item-cost-categories",
        "/item-cost-categories",
        "ItemCostCategories",
        SellIcon,
        (decoded) => decoded?.can_manage_item_cost_categories,
        (pathname) => pathname === "/item-cost-categories"
      ),
      link(
        "hourly-item-snapshots",
        "/hourly-item-snapshots",
        "HourlyItemSnapshots",
        AccessTimeIcon,
        (decoded) => decoded?.can_access_hourly_item_snapshots,
        (pathname) => pathname === "/hourly-item-snapshots"
      ),
    ],
  },
];

export function getSidebarItemLabel(item, t, language) {
  if (typeof item.getLabel === "function") {
    return item.getLabel(t, language);
  }
  return t(item.labelKey);
}

export function readCollapsedGroupIds(userId) {
  if (userId == null || userId === "") return [];
  try {
    const raw = localStorage.getItem(
      `bonreport.sidebar.collapsed.${userId}`
    );
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id) => typeof id === "string");
  } catch {
    return [];
  }
}

export function writeCollapsedGroupIds(userId, ids) {
  if (userId == null || userId === "") return;
  try {
    localStorage.setItem(
      `bonreport.sidebar.collapsed.${userId}`,
      JSON.stringify(ids)
    );
  } catch {
    // Keep every group expanded on the next visit if storage is unavailable.
  }
}
